import React, { useEffect, useState } from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Header from '../../Components/General/Header';
import LayoutComponent from '../../Components/General/LayoutComponent';
import ServicesContainer from '../../Components/General/ServicesContainer';
import TimeTable from '../../Components/General/TimeTable';
import Loader from '../../Components/UI/Loader';
import PaddingContainer from '../../Components/UI/PaddindContainer';
import useAppointment from '../../Features/useAppointment';
import useDoctor from '../../Features/useDoctor';
import usePackage from '../../Features/usePackages';
import useProfile from '../../Features/useProfile';
import useSMSPackage from '../../Features/useSMSPackage';
import AppointmentsAndFollowUp from './AppointmentsAndFollowUp';
import ProfileCard from './ProfileCard';
import classes from './Settings.module.css';
import SMSPage from './SmsPage';
import SubscriptionPage from './SubscriptionPage';
const Settings = () => {
  const navigate = useNavigate();
  const {
    getAllSMSPackages,
    smsPackages,
    getSmsSubscription,
    smsPackageSubscription,
    addSmsSubscription,
    deleteSmsSubscription
  } = useSMSPackage(); //Imports all api calling functions
  const { getAllServicesListing } = useDoctor(); // import packages
  const {
    getAllPackages,
    packages,
    addSubscription,
    addMergeSubscription,
    getPackageSubscription,
    packageSubscriptionList
  } = usePackage();

  const { addDoctorTime, loading: appointmentLoading } = useAppointment();
  const {
    getDoctorTime,
    doctorTimes,
    generateOtpForUpdateEmail,
    updateEmail,
    loading: profileLoading,
    updateSecondaryNumber,
    getProfile,
    updateProfileImage,
    patientDuration
  } = useProfile();

  const [loading, setLoading] = useState(false);
  const auth = useSelector((state) => state?.authReducer);
  const profile = auth?.profile;
  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true); // Start loading
      const apiCalls = [
        getDoctorTime(),
        getAllSMSPackages(),
        getAllPackages(),
        getProfile(),
        getPackageSubscription({
          pageNumber: 1,
          pageSize: 10,
          totalRowsCount: 0,
          sortField: '',
          sortDirection: '',
          search: '',
          filter: null
        }),
        getSmsSubscription({
          pageNumber: 1,
          pageSize: 10,
          totalRowsCount: 0,
          sortField: '',
          sortDirection: '',
          search: '',
          filter: null
        }),
        getAllServicesListing()
      ];
      try {
        const results = await Promise.allSettled(apiCalls);
        // Handle individual results
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            console.log(`API Call ${index + 1} succeeded:`, result.value);
          } else {
            console.error(`API Call ${index + 1} failed:`, result.reason);
          }
        });
      } catch (error) {
        console.error('Unexpected error:', error);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchAllData();
  }, []);
  const handleUpdateProfileImage = async (params) => {
    setLoading(true);
    await updateProfileImage(params);
    setLoading(false);
  };
  const onPrev = () => {
    navigate('/appointments');
  };
  const onNext = () => {
    navigate('/patient-list');
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <LayoutComponent>
          <Header title="Settings" onNext={onNext} onPrev={onPrev} />

          <PaddingContainer className={classes.pageWrapper}>
            <nav className="settings-tab">
              <Tabs>
                <Tab eventKey="settings" title="Settings">
                  <Row className={classes.settingsWrapper}>
                    <Col lg={5} className={classes.bgWhite}>
                      <div className={classes.leftContent}>
                        <ProfileCard
                          onUpdateProfileImage={handleUpdateProfileImage}
                          profile={profile}
                          loading={profileLoading}
                          generateOtpForUpdateEmail={generateOtpForUpdateEmail}
                          updateEmail={updateEmail}
                          updateSecondaryNumber={updateSecondaryNumber}
                        />
                        {/* <h2 className={classes.roleTitle}>Role Management</h2>
                        <Row>
                          <Col md={6}>
                            <RoleCard />
                          </Col>
                        </Row> */}

                        <AppointmentsAndFollowUp onSubmit={patientDuration} />
                      </div>
                    </Col>
                    <Col lg={7}>
                      <div className={classes.rightWrapper}>
                        <TimeTable
                          loading={profileLoading}
                          times={doctorTimes}
                          onSubmit={addDoctorTime}
                        />

                        <ServicesContainer />
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="sms" title="SMS">
                  <SMSPage
                    loading={loading}
                    smsPackagesList={smsPackages}
                    onAddSmsSubscription={addSmsSubscription}
                    subscriptionList={smsPackageSubscription}
                    onCancelRequest={deleteSmsSubscription}
                    getSmsSubscription={getSmsSubscription}
                  />
                </Tab>
                <Tab eventKey="subscription" title="Subscription">
                  <SubscriptionPage
                    subscriptionList={packageSubscriptionList}
                    packages={packages}
                    smsPackagesList={smsPackages}
                    onAddSubscription={addSubscription}
                    onAddMergeSubscription={addMergeSubscription}
                    onAddSmsSubscription={addSmsSubscription}
                  />
                </Tab>
              </Tabs>
            </nav>
          </PaddingContainer>
        </LayoutComponent>
      )}
    </>
  );
};

export default Settings;
